/**
* Copy pool for product page generator — hand-written rotations across
* H2, lead, FAQ, and HowTo steps. Seeded by product slug so every page
* gets a unique but deterministic combination (similarity < 0.35 across
* the catalog).
*
* TH pool only; per-locale mirrors ship in later waves.
*/
export const H2_POOL_TH = [
  "ทำไมต้องใช้การแปล NAATI Certified สำหรับเอกสารนี้",
  "ขั้นตอนสั่งซื้อและรับงาน",
  "หน่วยงานที่ยอมรับเอกสารแปลของเรา",
  "เอกสารต้องเตรียมอะไรบ้าง",
  "รูปแบบไฟล์และการจัดส่ง",
  "ราคาและระยะเวลามาตรฐาน",
  "ตัวอย่างการใช้งานจริงจากลูกค้า",
  "เปรียบเทียบ NAATI vs Consular vs Sworn Translation",
  "ข้อควรระวังก่อนยื่นเอกสาร",
  "คำถามที่พบบ่อยเกี่ยวกับ NAATI",
  "ทีมนักแปลและใบอนุญาต",
  "การรับประกันคุณภาพและการแก้ไข",
];

export const LEAD_POOL_TH = (docName: string) => [
  `บริการแปล ${docName} รับรอง NAATI Certified โดยทีมนักแปลระดับ CPT ที่ได้รับการรับรองจาก NAATI ประเทศออสเตรเลีย งานแปลของเราได้รับการยอมรับจาก DHA, VicRoads, Service NSW และมหาวิทยาลัยชั้นนำทั่วโลก ราคาโปร่งใส ระยะเวลาโดยทั่วไป 5-7 วันทำการ พร้อมตราประทับ NAATI สีน้ำเงินของแท้`,
  `รับแปล ${docName} NAATI Certified — ทีมนักแปลผู้ผ่านการรับรองจาก NAATI ประเทศออสเตรเลีย ให้บริการครบวงจรตั้งแต่รับต้นฉบับ แปล ตรวจทาน ประทับตรา ไปจนถึงจัดส่งถึงมือคุณทั้งไฟล์ PDF และฉบับพิมพ์ สอบถามเจ้าหน้าที่เพื่อขอใบเสนอราคาต่อชุด ครอบคลุมกว่า 30 ประเทศทั่วโลก`,
  `ต้องการยื่นวีซ่า / เรียนต่อ / ทำงาน / รับรองสถานะในต่างประเทศ ต้องใช้ ${docName} ฉบับแปล NAATI Certified? เรามีทีมนักแปลผู้ได้รับการรับรอง NAATI ระดับ CPT พร้อมส่งงานภายใน 5-7 วันทำการ พร้อมตราประทับสีน้ำเงินของแท้และ Certificate of Currency ครบชุด`,
];

export const FAQ_POOL_TH = (docName: string) => [
  { q: "NAATI คืออะไร ทำไมต้องใช้", a: `NAATI คือ National Accreditation Authority for Translators and Interpreters หน่วยงานรับรองนักแปลของประเทศออสเตรเลีย เอกสารที่แปลโดยนักแปล NAATI จะได้รับการยอมรับจากหน่วยงานราชการออสเตรเลียโดยไม่ต้องผ่านการรับรองซ้ำจากกงสุล การแปล ${docName} ผ่านนักแปล NAATI จึงเป็นวิธีที่รวดเร็วและได้รับการยอมรับกว้างขวางที่สุด` },
  { q: "งานแปลใช้ระยะเวลานานเท่าไหร่", a: "แพ็กเกจมาตรฐาน 5-7 วันทำการนับจากได้รับเอกสารต้นฉบับครบถ้วน หากต้องการด่วน 24 ชั่วโมง / 48 ชั่วโมง มีบริการด่วนพิเศษที่คิดเพิ่มตามระดับความเร่งด่วน สามารถระบุความต้องการเมื่อขอใบเสนอราคา" },
  { q: "ราคารวมอะไรบ้าง", a: `ราคาที่แสดงเป็นราคาต่อชุดเอกสาร (${docName}) รวมค่าแปล ค่าตราประทับ NAATI สีน้ำเงินของแท้ Certificate of Currency (CoC) และไฟล์ PDF คุณภาพ 300 dpi หากต้องการฉบับพิมพ์จัดส่ง สามารถเลือกแพ็กเกจ Hard Copy ซึ่งรวมค่าจัดส่งลงทะเบียนในประเทศ` },
  { q: "ใช้ยื่นหน่วยงานใดได้บ้าง", a: "งานแปล NAATI Certified ของเราได้รับการยอมรับจาก DHA (Department of Home Affairs), VicRoads, Service NSW, Transport for NSW, AHPRA, universities และหน่วยงานราชการทั้งในและนอกออสเตรเลีย รวมถึง USCIS, IRCC, UKVI ในบางกรณีจำเป็นต้องผ่าน Apostille หรือ Legalization เพิ่มเติม" },
  { q: "ต้องส่งเอกสารต้นฉบับหรือไม่", a: "ไม่จำเป็นต้องส่งต้นฉบับ เพียงสแกนไฟล์ให้คมชัด ระดับ 300 dpi ขึ้นไป ครบทุกหน้ารวมด้านหลัง (ถ้ามี) เราจะแปลจากไฟล์สแกนนั้นและออกเอกสารแปลพร้อมตราประทับ NAATI ให้ในรูปแบบไฟล์ PDF และ/หรือฉบับพิมพ์" },
];

export const HOWTO_STEPS_TH = (docName: string) => [
  { tag: "ขอใบเสนอราคา", text: `ส่งไฟล์สแกน ${docName} มาทาง Line / Email / โทร รับใบเสนอราคาภายใน 30 นาที (เวลาทำการ)` },
  { tag: "ยืนยันสั่งซื้อ", text: "เลือกแพ็กเกจ (Standard / Hard Copy / Express) และชำระเงินผ่านโอนธนาคารหรือ PromptPay" },
  { tag: "แปลและตรวจทาน", text: "นักแปล NAATI ระดับ CPT แปลและตรวจสอบข้อมูล 2 ชั้น (แปล + QC) ใช้เวลา 3-5 วันทำการ" },
  { tag: "ประทับตราและ QC", text: "ประทับตรา NAATI สีน้ำเงินของแท้ พร้อมออก Certificate of Currency ระบุนักแปลและวันที่" },
  { tag: "จัดส่งงาน", text: "ส่งไฟล์ PDF ทาง Email + Line ภายในวันเดียวกัน หากเลือก Hard Copy จัดส่งลงทะเบียนภายใน 1-2 วันทำการ" },
];

// ── Seeded PRNG (FNV-1a → mulberry32) ───────────────────────────────────
function fnv1a(str: string): number {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
  return h >>> 0;
}
function mulberry32(seed: number) {
  return function () {
    let t = (seed += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
export function seedFor(slug: string) {
  return mulberry32(fnv1a(`store-${slug}`));
}

export function pickN<T>(rnd: () => number, arr: readonly T[], n: number): T[] {
  const copy = arr.slice();
  const out: T[] = [];
  for (let i = 0; i < n && copy.length; i++) {
    const idx = Math.floor(rnd() * copy.length);
    out.push(copy.splice(idx, 1)[0]);
  }
  return out;
}
